import { useIntl } from "react-intl";

import ImageChecklistSide, {
    ListItemWithEmphsis
} from "../../../../../../../../patterns/image-checklist-side";

const ProductTeams = () => {
    const intl = useIntl();

    const title = intl.formatMessage({
        id: "JiraSoftwarePage.PaidLpJswPm.productTeams.headerText",
        defaultMessage: "Product teams"
    });

    const customerFocus = {
        strongText: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.productTeams.customerFocus.strongtext",
            defaultMessage: "Bring customer needs into focus:"
        }),
        plainText: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.productTeams.customerFocus.plainText",
            defaultMessage:
                " Gather all your product inputs in one place to ensure you’re building the right product and the right features to actually make an impact."
        })
    };

    const productPriorities = {
        strongText: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.productTeams.productPriorities.strongtext",
            defaultMessage: "Set product priorities as a team:"
        }),
        plainText: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.productTeams.productPriorities.plainText",
            defaultMessage:
                " Quickly sort your ideas to help your team tackle the highest priority items first and stay on top of your most important tasks."
        })
    };

    const ideationToDelivery = {
        strongText: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.productTeams.ideationToDelivery.strongtext",
            defaultMessage: "Move from ideation to customer delivery:"
        }),
        plainText: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.productTeams.ideationToDelivery.plainText",
            defaultMessage:
                " Get stakeholder feedback quickly with shareable links and custom timelines to get feedback across your company, and solicit votes and comments to help prioritize work."
        })
    };

    const listItems = [
        ListItemWithEmphsis(customerFocus),
        ListItemWithEmphsis(productPriorities),
        ListItemWithEmphsis(ideationToDelivery)
    ];
    const imageSrc =
        "https://wac-cdn.atlassian.com/dam/jcr:6b4f378b-2979-4acb-8edd-1c28e3514930/PRODUCT%20TEAMS@2x.png?cdnVersion=ece";
    const imageAlt = intl.formatMessage({
        id: "JiraSoftwarePage.PaidLpJswPm.productTeams.tabsImageAltText",
        defaultMessage: "Design teams"
    });

    const testimony = {
        isIncludeTestimony: true,
        quoteBlurb: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.productTeams.testimony.quoteBlurb",
            defaultMessage:
                "Jira has allowed a great deal of transparency across business and development teams – contributing to a product that's truly a collaborative effort every step of the way."
        }),
        quoteName: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.productTeams.testimony.quoteName",
            defaultMessage: "JEANNICE ANGELA"
        }),
        quoteCompany: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.productTeams.testimony.quoteCompany",
            defaultMessage: "PRODUCT MANAGER, RENT THE RUNWAY"
        }),
        testimonyImageClassName: "tab-testimony-image",
        testimonyImageSrc:
            "https://wac-cdn.atlassian.com/dam/jcr:44288302-8ed5-4ce2-94c0-015787b11d23/LP-logos_rent%20the%20runway%20logo.svg?cdnVersion=ece",
        testimonyImageAlt: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.productTeams.testimony.logo.imageAltText",
            defaultMessage: "Rent the Runway logo"
        })
    };

    return (
        <ImageChecklistSide
            title={title}
            listItems={listItems}
            imageSrc={imageSrc}
            imageAlt={imageAlt}
            isIncludeTestimony={testimony.isIncludeTestimony}
            quoteBlurb={testimony.quoteBlurb}
            quoteName={testimony.quoteName}
            quoteCompany={testimony.quoteCompany}
            testimonyImageClassName={testimony.testimonyImageClassName}
            testimonyImageSrc={testimony.testimonyImageSrc}
            testimonyImageAlt={testimony.testimonyImageAlt}
        />
    );
};

export default ProductTeams;
